import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
// import firebase from 'firebase'
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCj3AdvcJAAaSPz_8zjUG3RZbPQgiG8IT0",
  authDomain: "whatsdown-b23e3.firebaseapp.com",
  projectId: "whatsdown-b23e3",
  storageBucket: "whatsdown-b23e3.appspot.com",
  messagingSenderId: "339961039334",
  appId: "1:339961039334:web:b261e09c61425879f0ae27",
  measurementId: "G-EJ4FWRNY5E",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();


export {auth,provider};
